exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-69738d30]{font-size:1.25rem;font-weight:600;color:#2f2f2f}", ""]);

// exports
